import { forwardRef } from "react";
import { useModuleBEM } from "@b2bportal/core-themes";
import type { PlatformComponentProps } from "@b2bportal/core-types";
import { Card, Typography } from "@tenant/ui";
import clsx from "clsx";
import defaultStyles from "./CarShopSection.module.scss";
import { useCarsStyles } from "~core-cars/themes";
import { CoreCarsComponent } from "~core-cars/types";

export interface CarShopSectionComponentProps extends PlatformComponentProps {
  title?: string;
}
const COMPONENT_KEY = CoreCarsComponent.CarShopSection;

export const CarShopSection = forwardRef<
  HTMLElement,
  CarShopSectionComponentProps
>(({ className, children, title }, _ref) => {
  const styles = useCarsStyles(COMPONENT_KEY, defaultStyles);
  const [block, cn] = useModuleBEM(styles, COMPONENT_KEY);

  return (
    <Card className={clsx(block, className)}>
      {title != null ? (
        <Typography className={cn("title")} type="heading" size="xs">
          {title}
        </Typography>
      ) : null}
      {children}
    </Card>
  );
});
